/**
 * @description  kpi
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from './logic-base'

const kpiBiz = new Logic()

kpiBiz.getKpiMap = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.kpi.getKpiMap,
    data: data
  })
}

kpiBiz.getHostKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.kpi.getHostKpi,
    data: data
  })
}

kpiBiz.getHostIp = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.kpi.getHostIp,
    data: data
  })
}

kpiBiz.getHostChartData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.kpi.getHostChartData,
    data: data
  })
}

export default kpiBiz
